export default __webpack_public_path__ + "static/media/icon-mansfield-awards-mobile.47e3ebd4.svg";